import initOrderForm from '@/pages/shared/orderForm';
import initSliderCards from '@/pages/shared/sliderCards';
import { OrderFormContent } from '@/components/Forms/OrderForm';
import { FriendFormContent } from '@/components/Forms/FriendForm';
import { SlideItem } from '@/types/common';

import initModalFriend from './modalFriend';
import initSlider from './slider';
import initVideoModal from './videoModal';
import initObjectMap from './map';

interface ObjectModel {
  id: string;
  type: string;
  title: string;
  ref: string;
  price: string;
}

interface ObjectSimilar {
  id: string;
  count: number;
}

interface ObjectSliderMain {
  elementId: string;
  slides: number;
}

interface ObjectSliderModal {
  elementId: string;
  buttonId: string;
  planButtonId?: string;
  planIndex?: number | null;
  slides: SlideItem[];
  title: string;
  gallery: string;
}

interface ObjectVideoModal {
  elementId: string;
  buttonId: string;
  videoUrl?: string;
}

interface ObjectShare {
  root: string;
  button: string;
  content: FriendFormContent;
}

interface ObjectMap {
  apiKey: string;
  displayLat: number;
  displayLng: number;
  circleRadius: number;
}

interface ObjectData {
  model: ObjectModel;
  similar: ObjectSimilar;
  sliderMain: ObjectSliderMain;
  sliderModal: ObjectSliderModal;
  videoModal: ObjectVideoModal;
  share: ObjectShare;
  map?: ObjectMap;
}

interface ObjectPageContent {
  order: OrderFormContent;
}

interface ObjectConfig {
  lang: string;
  object: ObjectData;
  content: ObjectPageContent;
}

const initObjectPage = ({
  lang,
  object,
  content
}: ObjectConfig): void => {
  initSlider(object.sliderMain, object.sliderModal);
  initSliderCards(object.similar.id, object.similar.count);

  if (object.map) {
    initObjectMap(lang, object.map, 2000);
  }

  if (object.videoModal.videoUrl) {
    initVideoModal(object.videoModal as Required<ObjectVideoModal>);
  }

  initModalFriend(object.share, lang, object.model.id);

  const onSuccess = () => {
    if (typeof gtag === 'function') {
      gtag('event', 'send_request', {
        event_category: object.model.type,
        event_label: `${object.model.title} - ${object.model.ref}`,
        value: parseInt(object.model.price, 10)
      });
    }
  };

  initOrderForm({
    content: content.order,
    objectId: object.model.id,
    onSuccess
  });
};

export default initObjectPage;
